import React from 'react';
import { Chip, Stack, Tooltip } from '@mui/material';

import { IBieOnboardingValidationIssue } from './bieonboardingworkbench.models';
import {
  getBieIssueRemediation,
  IBieRenderedRemediation,
} from './bieonboarding.remediation';

export interface IBieIssueRemediationChipsProps {
  issue: IBieOnboardingValidationIssue;
  disabled?: boolean;
  onAction: (
    action: IBieRenderedRemediation,
    issue: IBieOnboardingValidationIssue,
  ) => void;
}

export default function BieIssueRemediationChips(
  props: IBieIssueRemediationChipsProps,
): React.ReactElement {
  const actions = getBieIssueRemediation(props.issue);

  return (
    <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
      {actions.map((action, index) => {
        const chip = (
          <Chip
            key={`${action.code}-${index}`}
            size="small"
            label={`${index + 1}  ${action.name}`}
            clickable={action.enabled !== false && !props.disabled}
            color={action.recommended ? 'primary' : 'default'}
            variant={action.recommended ? 'filled' : 'outlined'}
            disabled={action.enabled === false || props.disabled}
            onClick={() => props.onAction(action, props.issue)}
            sx={{ fontWeight: 700 }}
          />
        );

        return action.description ? (
          <Tooltip key={`${action.code}-${index}`} title={action.description}>
            {chip}
          </Tooltip>
        ) : chip;
      })}
    </Stack>
  );
}
